var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEqualizer = function SvgEqualizer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M19 25.333H2.667m16.333 0a3.333 3.333 0 1 0 6.667 0 3.333 3.333 0 0 0-6.667 0Zm10.333 0h-3.5M6.208 16H2.667m26.666 0H13.042m-.417-9.333H2.667m26.666 0h-10m0 0a3.333 3.333 0 1 0-6.667 0 3.333 3.333 0 0 0 6.667 0Zm-9.666 6a3.333 3.333 0 1 1 0 6.666 3.333 3.333 0 0 1 0-6.666Z"
  })));
};
export default SvgEqualizer;